import {pipeHandlers} from 'utils/reduxEffects';
import common from './common/handler';
import map from './mapPage/handler';

export default pipeHandlers(common, map);
